import { Component } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ProductService } from '../../../services/product/product.service';
import { IngredientService } from '../../../services/ingredient/ingredient.service';
import { OrdersService } from '../../../services/order/orders.service';
import { forkJoin } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ConstService } from '@app/services/const/const.service';

@Component({
    selector: 'personalize-product',
    templateUrl: 'personalize-product.component.html',
    styleUrls: ['personalize-product.component.scss'],
    providers: [ProductService, IngredientService]
})
export class PersonalizeProductComponent {
    product: any = {};
    ismenuproduct;
    unavComp = 0;
    unavSupp = 0;
    unavOpt = 0;
    optChecked: number = 0;
    loadAvatar = false;
    loading = true;
    labelOptions = "";
    product2: any = {};
    orderProg;
    chosenOrderType;
    idSize;
    priceSupp;
    productId:null;
    constructor(
        public bsModalRef: BsModalRef,
        private productService: ProductService,
        private ingredientsService: IngredientService,
        private orderService: OrdersService,
        private toastr: ToastrService,
        private constService: ConstService,
        private modalService: BsModalService
    ) {
        this.labelOptions = this.constService.labelOptions,
            this.optChecked = 0;
        this.orderService.orderProg.subscribe((orderProg) => {
            this.orderProg = orderProg;
        });
        this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
        });
    }
    ngOnInit() {
        setTimeout(
            () => {
                this.loading = true;
                if (this.product2.id) {
                    this.productId=this.product2.id;
                    this.getProduct()
                } else {
                    if(this.ismenuproduct){
                        this.productId=this.product.element;
                        this.idSize=this.product.idSize;
                        this.priceSupp=this.product.priceSupp;
                    }else{
                        this.productId=this.product.id;
                        this.idSize=this.product.sizes[this.product.size].idSize;
                        this.priceSupp=this.product.sizes[this.product.size].priceSupp;
                    }
                    this.getCompIng();
                }
            }, 100
        )
    }

    getProduct() {
        this.productService.getOrderProduct(this.product2.id, this.chosenOrderType, this.orderProg).subscribe(
            (p: any) => {
                this.product = p;
                this.product.qty = this.product2.qty;
                this.product.comment = this.product2.comment;
                this.product.size = this.product.sizes.findIndex(s => s.id == this.product2.size.id);
                this.idSize=this.product.sizes[this.product.size].idSize;
                this.priceSupp=this.product.sizes[this.product.size].priceSupp;
                forkJoin([
                    this.getCompositions(),
                    this.getOptions(),
                    this.getSupplements(),
                    this.getOptionsObligatoir()
                ]).subscribe(
                    (data: any[]) => {
                        this.loading = false;
                        this.product.compositions = data[0].map(p => {
                            p.label = p.text;
                            p.checked = this.product2.removedCompositions.findIndex(c => c.id == p.id) == -1;
                            return p;
                        })
                        this.unavComp = this.product.compositions.filter(comp => comp.disabled == 'true').length;
                        this.product.optionIngredients = data[1].map(p => {
                            p.label = p.text;
                            p.checked = this.product2.optionIngredients.findIndex(c => c.id == p.id) > -1
                            return p;
                        })
                        this.unavOpt = this.product.optionIngredients.filter(opt => opt.disabled == 'true').length;
                        this.product.selectedOpt = [];
                        this.product.supplements = data[2].map(p => {
                            p.label = p.text;
                            p.checked = this.product2.supplements.findIndex(c => c.id == p.id) > -1
                            return p;
                        })
                        this.unavSupp = this.product.supplements.filter(supp => supp.disabled == 'true').length;
                        this.product.selectedSupp = [];

                        this.product.obligatoryIngredient = [];
                        this.product.obligatoryIngredient = data[3];
                        this.product.optionIngredients.forEach(element => {
                            if (element.checked) {
                                this.optChecked++;
                            }
                        });
                        if (this.product.supplements.length > 0) {
                            this.setSuppPrices();
                        }
                    }
                )
            }
        )
    }


    getCompIng() {
        forkJoin([
            this.getCompositions(),
            this.getOptions(),
            this.getSupplements(),
            this.getOptionsObligatoir()
        ]).subscribe(
            (data: any[]) => {
                this.loading = false;
                this.product.compositions = data[0].map(p => {
                    p.label = p.text;
                    p.checked = true
                    return p;
                })
                this.unavComp = this.product.compositions.filter(comp => comp.disabled == 'true').length;
                this.product.optionIngredients = data[1].map(p => {
                    p.label = p.text;
                    return p;
                })
                this.unavOpt = this.product.optionIngredients.filter(opt => opt.disabled == 'true').length;
                this.product.selectedOpt = [];
                this.product.supplements = data[2].map(p => {
                    p.label = p.text;
                    return p;
                })
                this.unavSupp = this.product.supplements.filter(supp => supp.disabled == 'true').length;
                this.product.selectedSupp = [];
                this.product.obligatoryIngredient = [];
                this.product.obligatoryIngredient = data[3];
                if (this.product.supplements.length > 0) {
                    this.setSuppPrices();
                }
            }
        )
    }

    getcatSupp(value) {
        return value.reduce(function (rv, x) {
            let index = rv.indexOf(x.category);
            if (index == -1) {
                rv.push(x.category)
            }
            return rv;
        }, []);
    }

    setSuppPrices() {
        switch (Number(this.product.priceSuppApp)) {
            case 2: {
                let categories = this.getcatSupp(this.product.supplements);
                let arraRquest = [];
                categories.forEach(c => {
                    arraRquest.push(this.ingredientsService.getIngredientsCatFamSizeBySize(c, this.product.family,this.idSize))
                });
                forkJoin(arraRquest).subscribe(
                    (d) => {
                        d.forEach((data, index) => {
                            if (data.length > 0) {
                                let price = Number(data[0].price);
                                let cat = categories[index];
                                this.product.supplements.forEach(
                                    (s) => {
                                        if (s.category == cat) {
                                            s.price = price
                                        }
                                    }
                                )
                            }
                        })
                    }
                )
                break;
            }
            case 3: {
                this.product.supplements.forEach((el) => {
                    el.price = Number(this.priceSupp);
                });
                break;
            }
        }
    }

    getCompositions() {
        return this.productService.getProductCompositions(this.productId);
    }

    getOptions() {
        return this.productService.getProductOptionsIngredient(this.productId);
    }

    getSupplements() {
        return this.productService.getProductSupplements(this.productId);
    }

    getOptionsObligatoir() {
        return this.ingredientsService.getObligatoryIngredientOfProduct(this.productId);
    }

    addToBasket() {
        let error = 0;
        let product = JSON.parse(JSON.stringify(this.product));
        if (!(product.size >= 0)) {
            error++;
            this.toastr.error('Produit indisponible pour le moment', 'Attention', { positionClass: 'toast-top-center' })
            return;
        }
        product.selectedOpt = this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked);
        if (product.custom) {
            if (product.selectedOpt.length == 0) {
                error++;
                this.toastr.error('Merci d\'ajouter les options', 'Attention', { positionClass: 'toast-top-center' });
                return;
            } else {
                product.obligatoryIngredient.forEach(cat => {
                    let array = product.selectedOpt.filter(o => o.category == cat.id);
                    if (error == 0 && array.length < cat.maxNbrIngOptions) {
                        error++;
                        let message = "Merci de selectionner au moins \r\n" + cat.maxNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category;
                        this.toastr.error(message, 'Attention', { positionClass: 'toast-top-center' })
                        return;
                    }
                });
            }
        }
        if (error == 0) {
            let element = {
                id: this.product.id,
                code: this.product.code,
                avatar:this.product.avatar,
                name: this.product.name,
                family: this.product.family,
                size: this.product.sizes[this.product.size],
                comment: (this.product.comment) ? this.product.comment : '',
                qty: Number(this.product.qty),
                removedCompositions: this.product.compositions.filter(c => c.disabled == "false" && !c.checked),
                supplements: [],
                optionIngredients: this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked),
                total: 0,
                vat: this.product.vat,
                priceSuppApp: this.product.priceSuppApp,
                priceWithSupp: Number(this.product.sizes[this.product.size].price),
                maxNbrIngOptions: this.product.maxNbrIngOptions,
                hasSupp: this.product.hasSupp
            }
            this.product.selectedSupp = this.product.supplements.filter(c => c.disabled == "false" && c.checked);
            element.total += Number(element.size.price);
            if (this.product.selectedSupp && this.product.selectedSupp.length > 0) {
                element['supplements'] = (this.product.selectedSupp) ? this.product.selectedSupp : [];
                if (element.supplements.length > 0) {
                    element.supplements.forEach((ele, index, array) => {
                        let el = JSON.parse(JSON.stringify(ele));
                        element.total += Number(el.price);
                        if (index == array.length - 1) {
                            this.addElementToOrder(element)
                        }
                    });
                } else {
                    this.addElementToOrder(element)
                }
                // switch (Number(this.product.priceSuppApp)) {
                //     case 1: {
                //         element['supplements'] = (this.product.selectedSupp) ? this.product.selectedSupp : [];
                //         if (element.supplements.length > 0) {
                //             element.supplements.forEach((ele, index, array) => {
                //                 let el = JSON.parse(JSON.stringify(ele));
                //                 element.total += Number(el.price);
                //                 if (index == array.length - 1) {
                //                     this.addElementToOrder(element)
                //                 }
                //             });
                //         } else {
                //             this.addElementToOrder(element)
                //         }
                //         break;
                //     }
                //     case 2: {
                //         let arraRquest = [];
                //         this.product.selectedSupp.forEach(ele => {
                //             arraRquest.push(this.ingredientsService.getIngredientsCatFamSizeBySize(ele.category, this.product.family, element.size.idSize))
                //         });
                //         forkJoin(arraRquest).subscribe(
                //             (d) => {
                //                 d.forEach((data, index, array) => {
                //                     let el = JSON.parse(JSON.stringify(this.product.selectedSupp[index]));
                //                     if (data.length > 0) {
                //                         el.price = Number(data[0].price);
                //                     }
                //                     element.supplements.push(el);
                //                     element.total += +el.price;
                //                     if (array.length - 1 == index) {
                //                         this.addElementToOrder(element)
                //                     }
                //                 })
                //             }
                //         )
                //         break;
                //     }
                //     case 3: {
                //         this.product.selectedSupp.forEach((ele, index, array) => {
                //             let el = JSON.parse(JSON.stringify(ele));
                //             el.price = Number(element.size.priceSupp)
                //             element.supplements.push(el)
                //             element.total += el.price;
                //             if (index == array.length - 1) {
                //                 this.addElementToOrder(element)
                //             }
                //         });
                //         break;
                //     }
                // }
            } else {
                this.addElementToOrder(element);
            }
        }
    }

    valider() {
        let error = 0;
        let product = JSON.parse(JSON.stringify(this.product));
        if (product.custom) {
            product.selectedOpt = this.product.optionIngredients.filter(c => c.disabled == "false" && c.checked);
            if (product.selectedOpt.length == 0) {
                error++;
                this.toastr.error('Merci d\'ajouter les options', 'Attention', { positionClass: 'toast-top-center' });
                return;
            } else {
                product.obligatoryIngredient.forEach(cat => {
                    let array = product.selectedOpt.filter(o => o.category == cat.id);
                    if (error == 0 && array.length < cat.maxNbrIngOptions) {
                        error++;
                        let message = "Merci de selectionner au moins \r\n" + cat.maxNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category;
                        this.toastr.error(message, 'Attention', { positionClass: 'toast-top-center' })
                        return;
                    }
                });
            }
        }
        if (error == 0) {
            let data: any = true;
            this.modalService.setDismissReason(data)
            this.bsModalRef.hide();
        }
    }

    changeOption(opt) {
        if (opt.checked) {
            this.optChecked++;
        } else {
            this.optChecked--;
        }
    }
    incrQty() {
        this.product.total += this.product.total / this.product.qty;
        this.product.qty++;
    }
    decrQty() {
        if (this.product.qty > 1) {
            this.product.total -= this.product.total / this.product.qty;
            this.product.qty--;
        }
    }
    addElementToOrder(element) {
        if (!this.product2.id) {
            element.total *= Number(element.qty);
            this.orderService.addElementToOrder(element);
            this.bsModalRef.hide();
        } else {
            this.modalService.setDismissReason(element);
            this.bsModalRef.hide();
            this.bsModalRef = null;
        }
    }
}
